import { CardFooter } from "$components/card";
import { makeStyles } from "$components/mui-styles";
import { alpha } from "@material-ui/core";
import { DispensationStrategy } from "elephant-web/gql";
import { DispensedPrescriptionFooterItems } from "./dispensation-states/dispensed-prescription";
import { ExpiredPrescriptionFooterItems } from "./dispensation-states/expired-prescription";
import { PaperPrescriptionFooterItems } from "./dispensation-states/paper-prescription";
import { UndispensedPrescriptionFooterItems } from "./dispensation-states/undispensed-prescription";

const useStyles = makeStyles((theme) => ({
  // The one footer that overrides the shared style: an un-dispensed
  // prescription is highlighted with a brand-tinted background. Split the
  // footer's bottom padding evenly top/bottom so the text sits centred within
  // the coloured band instead of hugging its top edge.
  active: {
    background: alpha(theme.palette.brand.light, 0.2),
    color: theme.palette.black.main,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
}));

export const DispensationStatusFooter: FC<{
  dispensation?: {
    dispensedBy: string;
    createdAt: string;
    dispensationStrategy: DispensationStrategy;
  };
  prescriptionValidUntil: string;
  prescribedBy: string;
}> = ({ dispensation, prescriptionValidUntil, prescribedBy }) => {
  const classes = useStyles();
  let content: JSX.Element;

  const prescriptionIsExpired = new Date() > new Date(prescriptionValidUntil);

  if (!dispensation) {
    if (prescriptionIsExpired) {
      content = <ExpiredPrescriptionFooterItems prescribedBy={prescribedBy} />;
    } else {
      content = (
        <UndispensedPrescriptionFooterItems
          validUntil={prescriptionValidUntil}
        />
      );
    }
  } else {
    const { createdAt, dispensationStrategy, dispensedBy } = dispensation;

    if (dispensationStrategy === DispensationStrategy.IssuedPaperPrescription) {
      content = (
        <PaperPrescriptionFooterItems
          issuedBy={dispensedBy}
          issuedAt={createdAt}
        />
      );
    } else {
      content = (
        <DispensedPrescriptionFooterItems
          dispensedBy={dispensedBy}
          dispensedAt={createdAt}
        />
      );
    }
  }

  return (
    <CardFooter className={!dispensation ? classes.active : undefined}>
      {content}
    </CardFooter>
  );
};
